export default __webpack_public_path__ + "static/media/1649.2e9f4f8b.png";